import styled from 'styled-components';
import { Col, Row } from 'react-bootstrap';

export const SPostSidebar = styled(Row)`
  margin-bottom: 15px;
  padding-bottom: 15px;
`;

export const SPostSidebarItem = styled(Col)`
  margin-bottom: 25px;
  background: #ffffff;
  border-radius: 5px;
  padding: 20px;
  border: 1px solid ${props => props.theme.colors.grey};
  box-shadow: 0px 10px 60px #0d263b0d;
`;
